import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import * as S from "./selectors";
import * as UA from "./useActions";
import { X2yController } from "./types";

const { isArray } = Array;

type X2yData = ReturnType<ReturnType<typeof S.createGetX2yData>>;

export const createUseX2yData = (controller: X2yController) => {
  const getData = S.createGetX2yData(controller);

  function useX2yData(xId: number): X2yData;
  function useX2yData(xIds: number[]): X2yData;
  function useX2yData(xIdOrIds: number | number[]): X2yData;
  function useX2yData(xIdOrIds: number | number[]): X2yData {
    const xIds = isArray(xIdOrIds) ? xIdOrIds : [xIdOrIds];
    // Zajistím kontinuální referenci, aby mi memoizoval reselect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const xIdsStaticRef = useMemo(() => xIds, [xIds.length, ...xIds]);

    const x2yData = useSelector((s) => getData(s, xIdsStaticRef));
    return x2yData;
  }

  return useX2yData;
};

// AUTOFETCH
export const createUseX2yDataAUTOFETCH = (controller: X2yController) => {
  const useFetchData = UA.createUseFetchX2yCallback(controller);
  const useData = createUseX2yData(controller);

  function useX2yDataAUTOFETCH(xId: number): X2yData;
  function useX2yDataAUTOFETCH(xIds: number[]): X2yData;
  function useX2yDataAUTOFETCH(xIdOrIds: number | number[]): X2yData;
  function useX2yDataAUTOFETCH(xIdOrIds: number | number[]) {
    // Nechci testovat pro arr.length === 1, protože by to imo mátlo v redux dev tools,
    // chci dispatchovat bulk akci pro bulk operace, i když jsem vybral jenom 1 možnost
    const fetch = useFetchData();
    const x2yData = useData(xIdOrIds);

    const xIds = isArray(xIdOrIds) ? xIdOrIds : [xIdOrIds];

    useEffect(() => {
      if (x2yData.isReady) return;
      fetch(xIdOrIds);
    }, [xIds.length, ...xIds]); // eslint-disable-line

    return x2yData;
  }

  return useX2yDataAUTOFETCH;
};
